/**
 * Connecting with people on Otable is a request: they accept it, and you are connected both ways. Connections
 * see each other's whole profile (experience, publications, projects, reflections), what they share with
 * connections, and the action buttons; others see the About tab and a Connect button. Either can remove the
 * connection. Organisations, calls, labs and the like are followed, at once. Backend: /interact/follow-requests/ (interact/follow_request/viewsets.py).
 */
import { mutate } from 'swr';
import { axiosService } from 'shared/helpers/axios';

export const BASE = '/interact/follow-requests/';
export const NOTIFICATIONS_CHANGED = 'otable:notifications-changed';
export const SUMMARY_URL = `${BASE}summary/`;
export const stateUrl = (userId) => `${BASE}state/${userId}/`;
export const statesUrl = (ids) => `${BASE}states/?ids=${ids}`;
export const requestsUrl = (box) => `${BASE}?box=${box}`;
export const CONNECTIONS_URL = `${BASE}people/`;

/** Every follow-request view (buttons, the card, the page, notifications) fetches again. */
export const refreshFollows = () => {
  mutate((key) => typeof key === 'string' && (key.startsWith(BASE) || key.startsWith('/interact/notifications')));
  // the bell's list (NotificationContext) fetches again at once, not at its next 30 s poll
  window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED));
};

// Answering a request: Accept filled green; Decline (and Withdraw) outlined in neutral grey, the same size,
// clearly a button but not alarming (declining is not destructive)
export const ACCEPT_BUTTON = { size: 'small', variant: 'contained', color: 'success', disableElevation: true,
  sx: { minWidth: 76, fontWeight: 600 } };
export const DECLINE_BUTTON = { size: 'small', variant: 'outlined', color: 'inherit',
  sx: { minWidth: 76, fontWeight: 600, color: 'text.primary', borderColor: 'grey.400',
    '&:hover': { borderColor: 'grey.600', bgcolor: 'action.hover' } } };

export async function askToFollow(userId) {
  const res = await axiosService.post(BASE, { user: userId });
  refreshFollows();
  return res.data;
}

export async function answerRequest(requestId, verb) {          // 'accept' | 'decline' | 'withdraw'
  const res = await axiosService.post(`${BASE}${requestId}/${verb}/`);
  refreshFollows();
  return res.data;
}

/** End a connection, for both. */
export async function removeConnection(userId) {
  const res = await axiosService.delete(`${BASE}connections/${userId}/`);
  refreshFollows();
  return res.data;
}
